module.exports = __webpack_public_path__ + "static/media/cross-platform.308d7728.svg";